import React from 'react';
import './LanguageDropdown.css';
import DropdownMenu from './utils/DropdownMenu';

const LANGUAGES = [
    { code: 'fr', emoji: '🇫🇷', label: 'Français' },
    { code: 'en', emoji: '🇬🇧', label: 'English' },
    { code: 'es', emoji: '🇪🇸', label: 'Español' },
    { code: 'de', emoji: '🇩🇪', label: 'Deutsch' },
    { code: 'pt', emoji: '🇵🇹', label: 'Português' },
];

const ENABLED_LANGUAGES = ['fr', 'en', 'es', 'de', 'pt'];

const LanguageDropdown = ({ language, setLanguage }) => {
    const activeIndex = LANGUAGES.findIndex(l => l.code === language);
    const items = LANGUAGES.map(lang => ({
        icon: <span className='lang-flag' style={{ fontSize: 22 }}>{lang.emoji}</span>,
        label: lang.label,
        disabled: !ENABLED_LANGUAGES.includes(lang.code),
        onClick: ENABLED_LANGUAGES.includes(lang.code) ? () => setLanguage(lang.code) : undefined,
    }));
    return (
        <DropdownMenu
            items={items}
            activeIndex={activeIndex === -1 ? 0 : activeIndex}
            dropdownClassName='lang-dropdown'
            menuClassName='lang-menu'
            showButtonLabel={false}
        />
    );
};

export default LanguageDropdown; 
